import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CLessonInCourse } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import { getMe } from 'platform-components/src/components/user/selectors';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import NoLessonsPane from 'common.components/no-lessons-pane/no-lessons-pane';
import { getSearchStringCourseIdOrDefault } from 'utils/get-course';

import ActiveLessons from '../__active-lessons/course-view__active-lessons';
import AssignedLessons from '../__assigned-lessons/course-view__assigned-lessons';
import { ReduxTeacherStore } from '../../../typings';
import {
    getAssignedLessons,
    getAssignedLessonsLoadingStatus,
    getActiveLessons,
    getActiveLessonsLoadingStatus,
    // @ts-ignore
} from '../selectors';

interface HocProps {
    classId?: string;
    subject?: string;
}

interface CourseViewActiveTabProps extends HocProps {
    activeLessons: Array<CLessonInCourse>;
    assignedLessons: Array<CLessonInCourse>;
    activeLoadingStatus: LOADING_STATUSES;
    assignedLoadingStatus: LOADING_STATUSES;
}

export class CourseViewActiveTab extends React.PureComponent<CourseViewActiveTabProps> {
    render() {
        const { activeLessons, assignedLessons, activeLoadingStatus, assignedLoadingStatus, classId, subject } =
            this.props;
        const isLoading =
            activeLoadingStatus !== LOADING_STATUSES.SUCCESS || assignedLoadingStatus !== LOADING_STATUSES.SUCCESS;
        const shoudShowNoLessonsPane = !isLoading && assignedLessons.length === 0 && activeLessons.length === 0;
        const shouldShowAssignedTitle = !isLoading && assignedLessons.length > 0 && activeLessons.length > 0;

        return (
            <div className="course-view__current-course-lessons">
                {shoudShowNoLessonsPane && <NoLessonsPane titleId="courseView.assignedTab.noLessonsPane.text" />}
                <ActiveLessons classId={classId} subject={subject} />
                {shouldShowAssignedTitle && (
                    <div className="course-view__assigned-lessons-header">
                        <Text id="courseView.assignedLessons.title" />
                    </div>
                )}
                <AssignedLessons classId={classId} subject={subject} />
            </div>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, { classId, subject }: HocProps) => {
    const me = getMe(storeState);
    const currentYearCourseId = getCurrentYearCourseId(storeState, {
        classId,
        subject,
    });
    // специальный костыль для КМ-ов, чтобы они могли заходить в любые курсы по get-параметру
    const courseId = me ? getSearchStringCourseIdOrDefault(me, currentYearCourseId) : null;

    return {
        assignedLessons: getAssignedLessons(storeState, { courseId }),
        assignedLoadingStatus: getAssignedLessonsLoadingStatus(storeState, { courseId }),
        activeLessons: getActiveLessons(storeState, { courseId }),
        activeLoadingStatus: getActiveLessonsLoadingStatus(storeState, { courseId }),
    };
};

export default connect(mapStateToProps)(CourseViewActiveTab);
